import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { DeleteUserSuccess } from '../../../user/action-creators';
import { DELETE_USER_SUCCESS } from '../../../user/actions';

export const trackUserDeletedSuccess = (action$: Observable<DeleteUserSuccess>) =>
  action$.pipe(
    ofType(DELETE_USER_SUCCESS),
    map((action) => {
      if (window.analytics) {
        window.analytics.track('Account Deleted', {
          type: 'user',
          id: action.user.id,
          name: action.user.fullName,
          contact: action.user.email || action.user.telephone,
        });
      }
    }),
    filter(() => false)
  )